
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.3636 8.90645C15.7151 9.25792 16.2849 9.25792 16.6364 8.90645C16.9878 8.55498 16.9878 7.98513 16.6364 7.63366L12.6364 3.63366C12.2849 3.28219 11.7151 3.28219 11.3636 3.63366L7.36358 7.63366C7.01211 7.98513 7.01211 8.55498 7.36358 8.90645C7.71505 9.25792 8.2849 9.25792 8.63637 8.90645L12 5.54285L15.3636 8.90645ZM15.3636 15.0935C15.7151 14.742 16.2849 14.742 16.6364 15.0935C16.9878 15.445 16.9878 16.0148 16.6364 16.3663L12.6364 20.3663C12.2849 20.7177 11.7151 20.7177 11.3636 20.3663L7.36358 16.3663C7.01211 16.0148 7.01211 15.445 7.36358 15.0935C7.71505 14.742 8.2849 14.742 8.63637 15.0935L12 18.4571L15.3636 15.0935Z","fill":"#16171F"}})])
          )
        }
      }
    